export default () => ({
  visits: [],
  practitionerVisits: [],
  currentVisit: {},
  visitsTotal: 0,
  practitionerVisitsTotal: 0,
})
